/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { UserInput } from './UserInput';
const EmailUsersCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['subject', codecString],
    ['body', codecString],
    ['emailAllUsers', codecBoolean, 'email_all_users'],
    ['users', /* #__PURE__ */ codecArray(UserInput)],
]);
export class EmailUsersCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EmailUsersCourseDataParser.decode(input).map(res => new EmailUsersCourseData(res));
    }
    static unsafeDecode(input) {
        return EmailUsersCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EmailUsersCourseDataParser.encode(data);
    }
    static schema() {
        return EmailUsersCourseDataParser.schema();
    }
}
